let recentRelations;

export const filterRelations = (relations, searchOptions) => {
  if (!relations) return relations;
  if (!searchOptions) return relations;
  const options = {
    take: 20,
    includeInactive: false,
    crmTypes: [],
    type: null,
    ...searchOptions,
  };

  return relations.filter(x => {
    if (typeof x.isActive !== 'undefined' && !x.isActive && !options.includeInactive) return false;
    if (
      options.crmTypes &&
      options.crmTypes.length > 0 &&
      typeof x.crm !== 'undefined' &&
      options.crmTypes.indexOf(x.crm) === -1
    )
      return false;

    if (
      options.type &&
      options.type.length > 0 &&
      typeof x.type !== 'undefined' &&
      options.type.indexOf(x.type) === -1
    )
      return false;

    return true;
  });
};

export default {
  get: () => recentRelations,
  getFiltered: options => filterRelations(recentRelations, options),
  set(data) {
    recentRelations = data || [];
  },
};
